import type { WorkbenchModule } from '../types'

export const lifeModule: WorkbenchModule = {
  meta: { name: 'life', title: '学习生活', description: '宿舍电费与生活服务', version: '0.1.0' },
  routes: [
    { path: '/life', name: 'life', component: () => import('./views/LifeView.vue'), meta: { title: '生活查询' } },
    { path: '/life/library', name: 'life-library', component: () => import('./views/LibraryView.vue'), meta: { title: '图书馆' } }
  ],
  menuItem: { id: 'life', label: '学习生活', path: '/life', icon: 'zap', order: 30 }
}
